module.exports = __webpack_public_path__ + "static/media/DM-Positive-Clip-2.e6f57523.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/success/DM-Positive-Clip-2.mp3
// module id = 124
// module chunks = 0